import { MultiSelect } from "primereact/multiselect";
import * as client from "../../../client";
import { UseMutationResult } from "@tanstack/react-query";
import { UpdateReport } from "../../../api/routes";
import { Button } from "primereact/button";
import { useState } from "react";
import { SovHelperModal } from "./SovHelperModal";

export const EditSheets: React.FC<{
  reportId: string;
  sovs: client.Sov[];
  updateReport: UseMutationResult<
    client.UpdateReportResponse,
    Error,
    UpdateReport,
    unknown
  >;
}> = ({ reportId, sovs, updateReport }) => {
  const filenames = sovs.map((sov) => {
    return { name: sov.filename };
  });

  const selectedFilenames = sovs
    .filter((sov) => sov.is_enabled)
    .map((sov) => {
      return { name: sov.filename };
    });

  const [helperModalVisible, setHelperModalVisible] = useState(false);

  return (
    <>
      <SovHelperModal
        reportId={reportId}
        visible={helperModalVisible}
        setVisible={setHelperModalVisible}
      />
      <MultiSelect
        panelFooterTemplate={
          <Button
            label="Don't see your file?"
            text
            style={{ marginLeft: "12px", marginBottom: "12px" }}
            onClick={() => setHelperModalVisible(true)}
          />
        }
        disabled={updateReport.isPending}
        value={selectedFilenames}
        onChange={(e) => {
          const enabledFilenames = e.value as { name: string }[];
          const sovsUpdate = sovs.map((sov) => ({
            ...sov,
            is_enabled: enabledFilenames.some(
              ({ name }) => name === sov.filename
            ),
          }));
          updateReport.mutate({ sovs: sovsUpdate });
        }}
        options={filenames}
        optionLabel="name"
        placeholder="Select Files/Sheets"
        style={{ width: "260px" }}
        selectAllLabel="All"
      />
    </>
  );
};
